import { View } from 'foundations-components/components/View';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import CompanionTabWrapper from '../components/CompanionTabWrapper';
import QuizMeTabContainer from '../components/QuizMeTabContainer';
import SummarizeTab from '../components/SummarizeTab';
import AdaptToIndustryTab from '../components/AdaptToIndustryTab';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const InteractiveEducationLayout = ({
  displayInteractiveEducation,
  interactiveEducationEnabled,
  contentType,
  interactiveContentTrackingProps,
  interactiveEducationProps,
  lesson,
  lessonContentId,
  primaryContentId,
  videoId,
  videoTitle,
  contentPortalId,
  children
}) => {
  const {
    isNotLaptop
  } = useMediaQuery();
  const {
    handleTriggerAsyncQuizGeneration,
    generateQuizError,
    generateQuizLoading,
    onRegenerateSingleVideoQuiz,
    summary,
    summaryCorrelationId,
    summaryError,
    summaryLoading,
    refetchSummary,
    videoDuration
  } = interactiveEducationProps;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [children, interactiveEducationEnabled && isNotLaptop && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(AccordionTransition, {
        open: displayInteractiveEducation === 'QUIZ_ME',
        children: /*#__PURE__*/_jsx(QuizMeTabContainer, {
          additionalTracking: interactiveContentTrackingProps,
          asyncGenerateError: !!generateQuizError,
          asyncGenerateLoading: generateQuizLoading,
          contentType: contentType,
          lesson: lesson,
          lessonContentId: lessonContentId,
          onAsyncRegenerateQuiz: handleTriggerAsyncQuizGeneration,
          onRegenerateSingleVideoQuiz: onRegenerateSingleVideoQuiz,
          primaryContentId: primaryContentId
        })
      }), /*#__PURE__*/_jsx(AccordionTransition, {
        open: displayInteractiveEducation === 'SUMMARIZATION',
        children: /*#__PURE__*/_jsx(View, {
          paddingBlockStart: "400",
          children: /*#__PURE__*/_jsx(CompanionTabWrapper, {
            children: /*#__PURE__*/_jsx(SummarizeTab, {
              additionalTracking: interactiveContentTrackingProps,
              contentType: contentType,
              correlationId: summaryCorrelationId,
              lessonContentId: lessonContentId,
              primaryContentId: primaryContentId,
              refetchSummary: refetchSummary,
              summary: summary,
              summaryError: summaryError,
              summaryLoading: summaryLoading,
              videoDuration: videoDuration
            })
          })
        })
      }), /*#__PURE__*/_jsx(AccordionTransition, {
        open: displayInteractiveEducation === 'ADAPT_TO_INDUSTRY',
        children: /*#__PURE__*/_jsx(View, {
          paddingBlockStart: "400",
          children: /*#__PURE__*/_jsx(CompanionTabWrapper, {
            children: /*#__PURE__*/_jsx(AdaptToIndustryTab, {
              additionalTracking: interactiveContentTrackingProps,
              contentId: primaryContentId,
              contentPortalId: contentPortalId,
              contentType: contentType,
              videoId: videoId,
              videoTitle: videoTitle
            })
          })
        })
      })]
    })]
  });
};